/**
 * 失敗理由を人が読める文字列にする。
 * Firestore の PERMISSION_DENIED など、問い合わせ時の一次切り分けに使う。
 */
const toErrorMessage = (error: unknown) =>
  error instanceof Error ? error.message : String(error);

/**
 * シフト操作の失敗をログに残したうえで占い師に通知する。
 * `operation` は「繰り返しシフト作成」のような操作名。
 */
export const notifyScheduleError = (operation: string, error: unknown) => {
  console.error(`${operation}エラー:`, error);
  alert(`${operation}に失敗しました。時間をおいて再度お試しください。\n\n${toErrorMessage(error)}`);
};
